import React, { useEffect, useState, useRef } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
export const ClientSuccess = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('success-stories');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight - 100) {
          setIsVisible(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check on mount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // Auto-slide functionality
  useEffect(() => {
    if (isVisible) {
      const interval = setInterval(() => {
        setCurrentSlide(prev => (prev + 1) % testimonials.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [isVisible]);
  const testimonials = [{
    name: 'Brian Johnson',
    company: 'Real Estate Investor',
    quote: "Callvana's team transformed our lead generation process. Their cold calling expertise has doubled our qualified leads in just one month.",
    stars: 5
  }, {
    name: 'Alicia Thompson',
    company: 'Insurance Agency Owner',
    quote: 'The quality assurance team at Callvana ensures we only receive qualified leads. Our sales team is thriving with their support.',
    stars: 5
  }, {
    name: 'Richard Logan',
    company: 'Roofing Company',
    quote: "Callvana's pricing is unbeatable for the quality they deliver. Their cold callers have the precision of experts targeting the right prospects.",
    stars: 5
  }, {
    name: 'Sarah Martinez',
    company: 'Solar Installation',
    quote: 'Since partnering with Callvana, our appointment bookings have increased by 65%. Their team understands our target market perfectly.',
    stars: 5
  }, {
    name: 'Michael Chen',
    company: 'Real Estate Wholesaler',
    quote: "The virtual assistants provided by Callvana have streamlined our operations tremendously. We're closing more deals with less stress.",
    stars: 5
  }, {
    name: 'Jennifer Williams',
    company: 'Land Investment Firm',
    quote: 'Callvana helped us identify motivated sellers in our target counties. Their specialized approach to land acquisition has been invaluable.',
    stars: 5
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % testimonials.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  const goToSlide = index => {
    setCurrentSlide(index);
  };
  return <section id="success-stories" className="relative py-20 bg-gradient-to-b from-black to-gray-900 w-full overflow-hidden" data-id="element-108">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-109">
        <div className="absolute inset-0 opacity-5 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]" data-id="element-110"></div>
        {/* Animated circles */}
        <div className="absolute top-1/4 left-1/4 w-64 h-64 rounded-full bg-blue-primary/5 animate-pulse" style={{
        animationDuration: '6s'
      }} data-id="element-111"></div>
        <div className="absolute bottom-1/3 right-1/4 w-96 h-96 rounded-full bg-blue-light/5 animate-pulse" style={{
        animationDuration: '8s'
      }} data-id="element-112"></div>
      </div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-113">
        <div className="text-center mb-16" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 animate-fadeIn" data-id="element-115">
            Success{' '}
            <span className="text-blue-light relative" data-id="element-116">
              Stories
              <span className="absolute -inset-1 bg-blue-light/10 blur-md -z-10 rounded-lg" data-id="element-117"></span>
            </span>
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto animate-fadeIn" style={{
          animationDelay: '0.2s'
        }} data-id="element-118">
            Hear from the businesses who have achieved outstanding results with
            our experts by their side.
          </p>
        </div>
        {/* Testimonial Slider */}
        <div className="relative max-w-6xl mx-auto px-4 md:px-12" data-id="element-119">
          {/* Connecting string/line */}
          <div className="absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-blue-primary/30 to-transparent -translate-y-1/2 z-0" data-id="element-120"></div>
          {/* Animated data points on the line */}
          {[...Array(8)].map((_, i) => <div key={`data-point-${i}`} className="absolute top-1/2 w-2 h-2 rounded-full bg-blue-light/50 -translate-y-1/2 z-0 animate-pulse" style={{
          left: `${i * 12 + 4}%`,
          animationDuration: `${2 + i % 3}s`,
          animationDelay: `${i * 0.3}s`
        }} data-id="element-121"></div>)}
          {/* Slider container with overflow for horizontal scrolling */}
          <div ref={sliderRef} className="relative overflow-hidden" data-id="element-122">
            <div className="flex transition-transform duration-700 ease-in-out" style={{
            transform: `translateX(-${currentSlide * 100}%)`
          }} data-id="element-123">
              {testimonials.map((testimonial, index) => <div key={index} className="w-full flex-shrink-0 px-4" data-id="element-124">
                  <div className={`bg-gray-900/80 border border-gray-800 rounded-lg p-8 transition-all duration-500 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'} hover:border-blue-light/50 relative group h-full`} data-id="element-125">
                    {/* Animated highlight */}
                    <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-primary to-blue-light rounded-lg blur opacity-0 group-hover:opacity-15 transition duration-1000 group-hover:duration-200" data-id="element-126"></div>
                    <div className="flex flex-col h-full relative" data-id="element-127">
                      <div className="flex mb-4" data-id="element-128">
                        {[...Array(testimonial.stars)].map((_, i) => <Star key={i} size={20} className="fill-blue-light text-blue-light animate-pulse" style={{
                      animationDuration: '3s',
                      animationDelay: `${i * 0.1}s`
                    }} data-id="element-129" />)}
                      </div>
                      <blockquote className="text-gray-300 italic mb-6 flex-grow text-lg" data-id="element-130">
                        "{testimonial.quote}"
                      </blockquote>
                      <div className="flex flex-col" data-id="element-131">
                        <div className="text-white font-medium text-lg" data-id="element-132">
                          — {testimonial.name}
                        </div>
                        <div className="text-blue-light text-sm" data-id="element-133">
                          {testimonial.company}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
          </div>
          {/* Navigation buttons with increased size and padding */}
          <button onClick={prevSlide} className="absolute top-1/2 left-0 transform -translate-y-1/2 -translate-x-6 z-30 w-14 h-14 rounded-full bg-gray-900/80 border border-gray-700 flex items-center justify-center text-white hover:bg-blue-primary/20 hover:border-blue-light transition-all duration-300 focus:outline-none" aria-label="Previous slide" data-id="element-134">
            <ChevronLeft size={26} data-id="element-135" />
          </button>
          <button onClick={nextSlide} className="absolute top-1/2 right-0 transform -translate-y-1/2 translate-x-6 z-30 w-14 h-14 rounded-full bg-gray-900/80 border border-gray-700 flex items-center justify-center text-white hover:bg-blue-primary/20 hover:border-blue-light transition-all duration-300 focus:outline-none" aria-label="Next slide" data-id="element-136">
            <ChevronRight size={26} data-id="element-137" />
          </button>
        </div>
        {/* Pagination dots */}
        <div className="flex justify-center mt-8 space-x-2" data-id="element-138">
          {testimonials.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`w-3 h-3 rounded-full transition-all duration-300 focus:outline-none ${currentSlide === index ? 'bg-blue-light w-6' : 'bg-gray-600 hover:bg-gray-500'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-139" />)}
        </div>
      </div>
    </section>;
};